export default "__VITE_ASSET__BWUZtj3X__"